module.exports = {
      id: "gzhome-usage",
      viewBox: "0 0 29.037 17.12",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#gzhome",
      toString: function () {
        return this.url;
      }
    }